<template>
    <Auth title="Login">
        <template #heading>
            <h1 id="title" class="fw-bold mb-1">Welcome back</h1>
            <p class="text-dark fs-4">
                Sign in to your account to continue.
            </p>
        </template>
        <Alert ref="alert" class="alert-danger">
            {{ message }}
        </Alert>
        <Form ref="form" @submit="onSubmit">
            <div class="mb-3">
                <label for="email" class="text-dark text-sm fw-semibold mb-1">Email address</label>
                <InputField id="email" v-model="email" name="email" rules="required|email" label="Email" placeholder="Email" />
            </div>
            <div class="text-start">
                <label for="password" class="mb-1 fw-semibold text-sm text-dark">Password</label>
                <InputField id="password" v-model="password" name="password" rules="required" label="Password" type="password" placeholder="Password" />
            </div>
            <div class="mb-2">
                <Link :href="route('auth.page.password.recover')" class="fs-sm fw-medium d-block d-lg-inline-block mb-1"> Forgot Password? </Link>
            </div>

            <div class="d-flex flex-column justify-content-between align-items-start mt-4 mb-3">
                <div class="w-100">
                    <Button id="action" type="submit" :label="labels" :loading="loading" :done="done" :disabled="checkInput" class="btn bg-secondary text-light py-3 w-100" />
                </div>
            </div>
        </Form>
    </Auth>
</template>

<script lang="ts">
import { error } from '@/ts/app'
import Alert from '@/vue/components/Alert.vue'
import Button from '@/vue/components/Button.vue'
import Field from '@/vue/components/Field.vue'
import Form from '@/vue/components/Form.vue'
import InputField from '@/vue/components/InputField.vue'
import Link from '@/vue/components/Link.vue'
import Auth from '@/vue/templates/Auth.vue'
import { ButtonLabel } from '@/vue/utils/Button'
import { AxiosError } from 'axios'
import { isNull, isUndefined } from 'lodash'
import { Component, Ref, Vue, Watch, toNative } from 'vue-facing-decorator'

@Component({
    components: {
        Auth,
        Field,
        InputField,
        Form,
        Button,
        Alert,
        Link,
    },
})
class Login extends Vue {
    declare url?: {
        intended: string
    }

    message = ''

    email = ''
    password = ''

    loading = false
    done = false

    @Ref('form')
    readonly form!: InstanceType<typeof Form>

    @Ref('alert')
    readonly alert!: InstanceType<typeof Alert>

    @Watch('message')
    onMessageChanged(value: string) {
        if (value.length > 0) {
            this.alert.show()
        } else {
            this.alert.hide()
        }
    }

    get labels(): ButtonLabel {
        return {
            normal: 'Login to continue',
            loading: 'Logging In',
            done: 'Logged In',
        } as ButtonLabel
    }

    get intended(): string {
        if (isNull(this.url) || isUndefined(this.url)) {
            return this.route('dashboard.page')
        }
        return this.url?.intended
    }
    get checkInput(): boolean {
        return this.email.trim() === '' || this.password.trim() === ''
    }

    onSubmit(payload) {
        this.loading = true
        this.message = ''
        this.$http
            .post(this.route('login'), payload)
            .then(() => {
                //this.router.visit(this.intended, { replace: true })
                this.done = true

                setTimeout(() => {
                    location.replace(this.intended)
                    //this.router.visit(this.intended, { replace: true })
                }, 500)
            })
            .catch((e: AxiosError) => error(e, this))
            .finally(() => (this.loading = false))
    }
}

export default toNative(Login)
</script>
